<template>
  <a
    :class="{active}"
    :href="path"
    class="menu-item"
    @click.prevent="onClick">
    Products
  </a>
</template>

<script>
export default {
  data() {
    return {
      path: '/products'
    };
  },
  computed: {
    active() {
      return this.path === this.$store.path;
    }
  },
  methods: {
    onClick() {
      this.$store.navigate(this.path, {});
    }
  }
};
</script>
